<template>
  <div :class="class" class="ui-pagination">
    <UiButtonIconRounded
      class="ui-pagination__prev"
      @click="previous"
      :disabled="previousDisabled"
    >
      <IconChevronDown />
    </UiButtonIconRounded>

    <span v-if="current && total" class="ui-pagination__text tabular-nums">
      {{ current }}
      /
      {{ total }}
    </span>

    <UiButtonIconRounded
      class="ui-pagination__next"
      @click="next"
      :disabled="nextDisabled"
    >
      <IconChevronDown />
    </UiButtonIconRounded>
  </div>
</template>

<script setup lang="ts">
import UiButtonIconRounded from './UiButtonIconRounded.vue'
import IconChevronDown from './icons/IconChevronDown.vue'

type Props = {
  current?: number
  total?: number
  previousDisabled?: boolean
  nextDisabled?: boolean
  class?: string
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'previous'): void
  (e: 'next'): void
}>()

const previous = () => emit('previous')
const next = () => emit('next')
</script>

<style lang="scss">
@import '../styles/config';

.ui-pagination {
  display: flex;
  align-items: center;
}

.ui-pagination__text {
  display: block;
  min-width: 3.75rem;
  margin: 0 0.5rem 0 0;
  font-family: $font-barlow;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
}

.ui-pagination__prev {
  margin-right: 0.5rem;

  svg {
    transform: rotate(90deg);
  }
}

.ui-pagination__next {
  svg {
    transform: rotate(-90deg);
  }
}
</style>
